<template>
    <div class="new-chart">
        <div class="chart-name">
            <v-input
                v-model="chartName"
                v-validate="'max:100'"
                :error-messages="errors.collect('chartName')"
                data-vv-name="chartName"
                data-vv-as="chart name"
            >
                <input v-model="chartName" type="text" placeholder="Chart Name" />
            </v-input>
        </div>
        <Filters :filters="chart.filters"
            :chartTypes="chartTypes"
            :cumulativeTypes="cumulativeTypes"
            :growthRates="growthRates"
            :growthRatesQuarters="growthRatesQuarters"
            :companies="companies"
            :categories="categories"
            :subcategories="subcategories"
            :classes="classes"
            :ranges="ranges"
            :revenueFilterRanges="revenueFilterRanges"
            :revenues="revenues"
            :brands="brands"
            :excludeBrands="excludeBrands"
            :quarterData="quarterData"
            :tags="tags"
            :action-text="'Create Chart'"
            @apply="applyFilters">
        </Filters>
    </div>
</template>

<script>

import Filters from './FiltersComponent.vue';

export default {
    props: {
        chart: {
            type: Object,
        },
        chartTypes: {
            type: Array,
        },
        cumulativeTypes: {
            type: Array,
        },
        growthRates: {
            type: Array,
        },
        growthRatesQuarters: {
            type: Array,
        },
        companies: {
            type: Array,
        },
        categories: {
            type: Array,
        },
        subcategories: {
            type: Array,
        },
        classes: {
            type: Array,
        },
        ranges: {
            type: Array,
        },
        revenueFilterRanges: {
            type: Array,
        },
        revenues: {
            type: Array,
        },
        brands: {
            type: Array,
        },
        excludeBrands: {
            type: Array,
        },
        quarterData: {
            type: Array,
        },
        tags: {
            type: Array,
        },
        curves: {
            type: Array,
        }
    },
    components: {
        Filters,
    },
    data() {
        return {
            chartName: '',
        };
    },
    created() {
        this.$emit('loading');
    },
    mounted() {
        this.$nextTick(() => {
            this.$emit('loaded');
            this.chartName = this.chart.name;
        });
    },
    methods: {
        async applyFilters(filtersData) {
            const valid = await this.$validator.validate();

            if (valid) {
                await this.$store.dispatch('chart/applyFilters', {
                    filters: filtersData,
                    firstInit: true,
                    chartName: this.chartName,
                });
            }
        },
    },
};

</script>

<style lang="scss">
    @import '../../style/Charts/NewChartComponent.scss';
</style>
